import { render } from "./ManagePro.vue?vue&type=template&id=894f2324"
import script from "./ManagePro.vue?vue&type=script&lang=js"
export * from "./ManagePro.vue?vue&type=script&lang=js"

import "./ManagePro.vue?vue&type=style&index=0&id=894f2324&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__